import Payment from "../../../../Services/PaymentProcessor/Payment";
import { CCAnnualFee } from "../../../Physician/Models/CCBlock";

export default class CCAnnualFeePayment {
    constructor(fees: Array<CCAnnualFee>, payment: Payment) {
        this.years = fees.map(_ => _.year);
        this.payment = payment;
    }
    years: Array<number>;
    payment: Payment;
}

